var map = {
	"./1.jpg": 1151,
	"./2.jpg": 4873,
	"./3.jpg": 4417,
	"./4.jpg": 1072,
	"./5.jpg": 1846,
	"./6.jpg": 2270,
	"./7.jpg": 9987,
	"./8.jpg": 2030
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1878;